import React from 'react'
import "./footer.css"

const Footer = () => {
  return (
    <div className='footer'>
      <div className='footer-div'>By <a href="https://nightingaleheart.com/">Innovation in Medicine</a></div>
    </div>
  )
}

export default Footer